import React, { Fragment, useEffect, useState } from "react";
import { Formik } from "formik";
import { Box, Card, CardContent, FormControl, FormHelperText, Grid, Paper, Typography } from "@mui/material";
import Button from "../../Common/Button";
import { useDispatch } from "react-redux";
import { setSnackBar } from "../../../store/common/commonSlice";
import Input from "../../Common/Input";
import { CommonFileUploadToServer } from "../../Common/CommonFileUploadToServer";
import { useUpdateAboutPageCMSMutation } from "../../../store/cms/cmsApis";
import { ProfileValidation } from "./validation.js";
import { workStatus } from "../../../helpers/sampleData.js";
import { useGetGotraListQuery, useGetQualificationListQuery } from "../../../store/masters/mastersApis.js";
import BasicSelect from "../../Common/Select.jsx";
import DatePickerComponent from "../../Common/DatePicker.jsx";
import StyledTextarea from "../../Common/StyledTextarea.jsx";
import IconButtonIcons from "../../Common/IconButtonIcons.jsx";
import { FamilyMemberAdd } from "../members-manager/FamilyMemberAdd.jsx";
import { useUpdateMembersMutation } from "../../../store/members/membersApis.js";
import { Add, DeleteOutlined, EditOutlined } from "@mui/icons-material";
import { handleDateTimeDefault } from "../../../helpers/utils.js";
import { format, parseISO } from "date-fns";
import CommonModal from "../../Common/CommonModal.jsx";
import { useUpdateSansthaMutation } from "../../../store/sanstha/sansthaApis.js";

const initialFamilyData = {
    name: "",
    gender: "",
    mobile: "",
    dob: "",
    qualification: "",
    married: "",
    marriage_date: "",
    blood_group: "",
    note: "",
    relation: "",
}

export const ProfileForm = ({ initialValue, roles }) => {
    const dispatch = useDispatch();
    const [updateMembers, { isLoading: updateMembersLoading }] = useUpdateMembersMutation();
    const [updateSanstha, { isLoading: updateSansthaLoading }] = useUpdateSansthaMutation();

    const [showModal, setShowModal] = useState(false);
    const [familyMemberInitalval, setFamilyMemberInitalval] = useState(initialFamilyData);
    const [familyEditKey, setFamilyEditKey] = useState(false);
    const [familyMemberData, setFamilyMemberData] = useState([]);

    useEffect(() => {
        setFamilyMemberData(initialValue?.family_details || []);
    }, [initialValue]);

    const { data: gotraData } = useGetGotraListQuery({ pageNo: 0, limit: 1000, sortBy: -1, sortField: "createdAt", active: true });
    const { data: qualificationData } = useGetQualificationListQuery({ pageNo: 0, limit: 1000, sortBy: -1, sortField: "createdAt", active: true });

    const onFormSubmit = async (values, { resetForm }) => {
        try {
            if (roles === "users") {
                let payload = { ...values };
                payload.family_details = familyMemberData;

                await updateMembers(payload)
            } else if (roles === "sanstha") {
                await updateSanstha(values)
            }
            dispatch(setSnackBar({
                open: true,
                message: "Profile updated successfully",
                severity: "success",
            }))
        } catch (error) {
            dispatch(setSnackBar({
                open: true,
                message: error?.data?.message || error.message,
                severity: "error",
            }))
        }
    };

    const handleAddFamilyMember = () => {
        setShowModal(true);
    }

    const handleDeleteFamilyMember = (data, key) => {
        let oldData = JSON.parse(JSON.stringify(familyMemberData));
        oldData.splice(key, 1);
        setFamilyMemberData(oldData);
    }

    const handleEditFamilyMember = (data, key) => {
        setFamilyEditKey(key)
        setFamilyMemberInitalval(data)
        setShowModal(true);
    }

    const FamilyMemberComponent = () => {

        const onFamilySubmit = (val) => {
            let oldData = JSON.parse(JSON.stringify(familyMemberData));

            if (familyEditKey !== false) {
                oldData[familyEditKey] = val;
            } else {
                oldData.push(val);
            }
            setFamilyMemberData(oldData);
            setFamilyMemberInitalval(initialFamilyData);
            setFamilyEditKey(false)
            setShowModal(false);
        }

        return (
            <FamilyMemberAdd familyMemberInitalval={familyMemberInitalval} submit={onFamilySubmit} qualificationData={qualificationData} />
        )
    }

    return (
        <Formik
            initialValues={initialValue}
            onSubmit={(values, action) => onFormSubmit(values, action)}
            validationSchema={ProfileValidation}
            enableReinitialize
        >
            {({
                handleChange,
                handleBlur,
                handleSubmit,
                values,
                errors,
                setFieldValue
            }) => (
                <Grid sx={{ display: "flex" }} direction={"column"} width={"100%"} height={"100%"} >
                    <Grid flex={1} overflow={"auto"}>
                        <Grid container spacing={2} pt={2} >
                            {
                                roles === "users" ? (
                                    <Grid item xs={12} md={12}>
                                        <CommonFileUploadToServer
                                            name="profile"
                                            onChange={(val) => setFieldValue("profile", val)}
                                            value={values?.profile || ""}
                                            label="Profile Picture"
                                            error={Boolean(errors.profile)}
                                            helperText={errors.profile}
                                            labelSecondary="Upload"
                                        />
                                    </Grid>
                                ) : roles === "sanstha" ? (
                                    <Grid item xs={12} md={12}>
                                        <CommonFileUploadToServer
                                            name="logo"
                                            onChange={(val) => setFieldValue("logo", val)}
                                            value={values?.logo || ""}
                                            label="Logo"
                                            labelSecondary="Upload"
                                            error={Boolean(errors.logo)}
                                            helperText={errors.logo}
                                        />
                                    </Grid>
                                ) : null
                            }

                            <Grid item xs={12} md={4}>
                                <Input
                                    id='name'
                                    name="name"
                                    label="Name *"
                                    onChange={handleChange("name")}
                                    value={values?.name || ""}
                                    error={Boolean(errors.name)}
                                    helperText={errors.name}
                                    fullWidth
                                    disabled={roles === "admin"}
                                />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <Input
                                    id='email'
                                    name="email"
                                    label="Email *"
                                    onChange={handleChange("email")}
                                    value={values?.email || ""}
                                    error={Boolean(errors.email)}
                                    helperText={errors.email}
                                    fullWidth
                                    disabled={roles === "admin"}
                                />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <Input
                                    id='mobile'
                                    name="mobile"
                                    label="Mobile *"
                                    onChange={handleChange("mobile")}
                                    value={values?.mobile || ""}
                                    error={Boolean(errors.mobile)}
                                    helperText={errors.mobile}
                                    fullWidth
                                    disabled={roles === "admin"}
                                />
                            </Grid>
                            {
                                roles === "users" && (
                                    <Fragment>
                                        <Grid item xs={12} md={4}>
                                            <Input
                                                id='alternate_no'
                                                name="alternate_no"
                                                label="Alternate Number"
                                                onChange={handleChange("alternate_no")}
                                                value={values?.alternate_no || ""}
                                                error={Boolean(errors.alternate_no)}
                                                helperText={errors.alternate_no}
                                                fullWidth
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <DatePickerComponent
                                                id={"dob"}
                                                name={"dob"}
                                                label="Date of Birth"
                                                onChange={(val) => setFieldValue("dob", val)}
                                                value={values?.dob ? new Date(values?.dob) : null}
                                                fullWidth
                                                onBlur={handleBlur}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <BasicSelect
                                                size="small"
                                                value={values?.gender || "male"}
                                                onChange={handleChange("gender")}
                                                displayEmpty
                                                label="Gender"
                                                name="gender"
                                                id="gender"
                                                items={[
                                                    { label: "Male", value: "male" },
                                                    { label: "Female", value: "female" },
                                                ]}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <BasicSelect
                                                size="small"
                                                value={values?.gotra || ""}
                                                onChange={handleChange("gotra")}
                                                displayEmpty
                                                label="Gotra"
                                                name="gotra"
                                                id="gotra"
                                                items={gotraData || []}
                                                error={Boolean(errors.gotra)}
                                                helperText={errors.gotra}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <BasicSelect
                                                size="small"
                                                value={values?.work_status || ""}
                                                onChange={handleChange("work_status")}
                                                displayEmpty
                                                label="Your Work Status"
                                                name="work_status"
                                                id="work_status"
                                                items={workStatus}
                                                error={Boolean(errors.work_status)}
                                                helperText={errors.work_status}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <Input
                                                id='native_place'
                                                name="native_place"
                                                label="Native Place"
                                                onChange={handleChange("native_place")}
                                                value={values?.native_place || ""}
                                                error={Boolean(errors.native_place)}
                                                helperText={errors.native_place}
                                                fullWidth
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <DatePickerComponent
                                                id={"marriage_date"}
                                                name={"marriage_date"}
                                                label="Marriage Date"
                                                onChange={(val) => setFieldValue("marriage_date", val)}
                                                value={values?.marriage_date ? new Date(values?.marriage_date) : null}
                                                fullWidth
                                                onBlur={handleBlur}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={12}>
                                            <StyledTextarea
                                                id='address'
                                                name="address"
                                                minRows={4}
                                                label="Address"
                                                onChange={handleChange("address")}
                                                value={values?.address || ""}
                                                error={Boolean(errors.address)}
                                                helperText={errors.address}
                                                fullWidth
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <Input
                                                id='city'
                                                name="city"
                                                label="City"
                                                onChange={handleChange("city")}
                                                value={values?.city || ""}
                                                error={Boolean(errors.city)}
                                                helperText={errors.city}
                                                fullWidth
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <Input
                                                id='state'
                                                name="state"
                                                label="State"
                                                onChange={handleChange("state")}
                                                value={values?.state || ""}
                                                error={Boolean(errors.state)}
                                                helperText={errors.state}
                                                fullWidth
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <Input
                                                id='zipcode'
                                                name="zipcode"
                                                label="Zipcode"
                                                onChange={handleChange("zipcode")}
                                                value={values?.zipcode || ""}
                                                error={Boolean(errors.zipcode)}
                                                helperText={errors.zipcode}
                                                fullWidth
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={12}>
                                            <StyledTextarea
                                                id='bio'
                                                name="bio"
                                                minRows={4}
                                                label="Bio"
                                                onChange={handleChange("bio")}
                                                value={values?.bio || ""}
                                                error={Boolean(errors.bio)}
                                                helperText={errors.bio}
                                                fullWidth
                                            />
                                        </Grid>

                                        <Grid item xs={12} md={12}>
                                            <Grid item xs={12} md={12} display={"flex"} gap={2} flexDirection={"row"} alignItems={"center"}>
                                                <Typography variant="h6">Family Details</Typography>
                                                <IconButtonIcons size="small" color="info" onClick={() => handleAddFamilyMember()} IconComponent={Add} />
                                            </Grid>
                                            {
                                                familyMemberData && familyMemberData.length > 0
                                                    ?
                                                    <Fragment>
                                                        <Grid item xs={12} md={12}>
                                                            <Grid container spacing={2}>
                                                                {
                                                                    familyMemberData.map((obj, key) => {
                                                                        return (
                                                                            <Grid item xs={12} md={3} key={key}>
                                                                                <Card variant="outlined" sx={{ position: "relative" }}>
                                                                                    <CardContent>
                                                                                        {
                                                                                            obj.relation || obj?.gender ? (
                                                                                                <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                                                                                                    {obj.relation} {obj?.gender ? `(${obj?.gender})` : ""}
                                                                                                </Typography>
                                                                                            ) : null
                                                                                        }

                                                                                        <Typography variant="h5" component="div">
                                                                                            {obj.name}
                                                                                        </Typography>
                                                                                        <Typography sx={{ mb: 1.5 }} color="text.secondary">
                                                                                            {obj.dob ? handleDateTimeDefault(obj?.dob) : null}
                                                                                        </Typography>
                                                                                        <Typography variant="body2">
                                                                                            {obj?.mobile ? <Fragment>Mobile: {obj?.mobile}</Fragment> : null}
                                                                                            {obj?.qualification ? <Fragment><br />Qualification: {obj?.qualification}</Fragment> : null}
                                                                                            {obj?.married !== "" && obj.marriage_date && obj.marriage_date !== "Invalid date" ? <Fragment><br />Marriage Date: {obj?.married ? format(new Date(parseISO(obj.marriage_date)), "dd MMM,yyyy") : ""}</Fragment> : null}
                                                                                            {obj?.blood_group ? <Fragment><br />`Blood Group: ${obj?.blood_group}`</Fragment> : null}
                                                                                            {obj?.note ? <Fragment><br />Note: {obj?.note}</Fragment> : null}
                                                                                        </Typography>
                                                                                        <Box sx={{ position: "absolute", right: 0, top: 0 }}>
                                                                                            <IconButtonIcons color="info" title="Edit" IconComponent={EditOutlined} onClick={() => handleEditFamilyMember(obj, key)} />
                                                                                            <IconButtonIcons color="error" title="Delete" IconComponent={DeleteOutlined} onClick={() => handleDeleteFamilyMember(obj, key)} />
                                                                                        </Box>
                                                                                    </CardContent>
                                                                                </Card>
                                                                            </Grid>
                                                                        )
                                                                    })
                                                                }
                                                            </Grid>
                                                        </Grid>
                                                    </Fragment>
                                                    :
                                                    null
                                            }
                                        </Grid>
                                    </Fragment>
                                )
                            }
                        </Grid>
                    </Grid>
                    {
                        roles !== "admin" && (
                            <Grid flexShrink={0} borderTop={1} borderColor={"rgba(152, 188, 252, 0.16)"} sx={{ padding: "8px 16px" }}>
                                <Grid sx={{ display: "flex", justifyContent: "flex-end" }}>
                                    <Grid sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                        <Button size="large" type="submit" loading={false} onClick={() => handleSubmit()}>Save</Button>
                                    </Grid>
                                </Grid>
                            </Grid>
                        )
                    }
                    <CommonModal show={showModal} close={() => setShowModal(false)} title="Add Family Member" child_component={<FamilyMemberComponent />} />
                </Grid>
            )
            }
        </Formik >
    )
}